module.exports = __webpack_public_path__ + "media/01.15b31e79.wav";